import { ProfileData } from "@interfaces/auth";
import gate from "gate";
import Cookies from "js-cookie";
import {useQuery, useQueryClient, UseQueryOptions, UseQueryResult} from "react-query";
import {useDispatch, useSelector} from "react-redux";
import {logout} from "@store/reducers/auth";

interface Props {
  options: Omit<
    UseQueryOptions<unknown, unknown, any, "profile">,
    "queryKey" | "queryFn"
  >;
}

const useProfile = (
  options?: Props["options"]
): UseQueryResult<ProfileData, unknown> => {
  const dispatch = useDispatch();
  const query = useQueryClient();
  const clearCookies = async () => {
    await dispatch(logout(""));
    await query.invalidateQueries();
  };
  const { profile } = useSelector((state: any) => state?.auth);
  return useQuery("profile", () => gate.profile({ peopleId: profile?.id }), {
    select: ({ data }: any) => data?.peopleInfo,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    enabled: !!Cookies.get("access_token"),

    ...options,
    onError: (error) => {
      clearCookies().then(() => {
        window.location.reload();
      });
      console.log(error);
    },
  });
};

export default useProfile;
